import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const NotFound = () => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
            <SEO
                title="Page Not Found | BPO Consultants"
                description="The page you are looking for feels like it's in another time zone. Let's get you back home."
            />
            <div className="max-w-md w-full space-y-8 text-center">
                <h1 className="text-9xl font-extrabold text-[#A2CB52]">404</h1>
                <h2 className="mt-6 text-3xl font-bold text-gray-900">Page Not Found</h2>
                <p className="mt-2 text-sm text-gray-600">
                    Sorry, we couldn't find the page you're looking for.
                </p>
                <div className="mt-5">
                    <Link
                        to="/"
                        className="font-medium text-[#A2CB52] hover:text-[#B5D575]"
                    >
                        Go back home
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
